import axios from 'axios';

export interface SpellCheckMatch {
  message: string;
  shortMessage: string;
  replacements: Array<{
    value: string;
    shortDescription?: string;
  }>;
  offset: number;
  length: number;
  context: {
    text: string;
    offset: number;
    length: number;
  };
  sentence: string;
  type: {
    typeName: string;
  };
  rule: {
    id: string;
    description: string;
    issueType: string;
    category: {
      id: string;
      name: string;
    };
    isPremium: boolean;
    confidence: number;
  };
}

export interface SpellCheckResponse {
  software: {
    name: string;
    version: string;
    buildDate: string;
    apiVersion: number;
    premium: boolean;
    premiumHint: string;
    status: string;
  };
  warnings: {
    incompleteResults: boolean;
  };
  language: {
    name: string;
    code: string;
    detectedLanguage: {
      name: string;
      code: string;
      confidence: number;
      source: string;
    };
  };
  matches: SpellCheckMatch[];
  sentenceRanges: number[][];
  extendedSentenceRanges: Array<{
    from: number;
    to: number;
    detectedLanguages: Array<{
      language: string;
      rate: number;
    }>;
  }>;
}

export const spellCheckerService = {
  async checkSpelling(text: string, language: string = 'en-US'): Promise<SpellCheckResponse> {
    const formData = new URLSearchParams();
    formData.append('text', text);
    formData.append('language', language);
    formData.append('enabledOnly', 'false');
    formData.append('username', 'jules@collegeapply.ai');
    formData.append('apiKey', 'dd313e5afaa3274b');

    const response = await axios.post('https://api.languagetoolplus.com/v2/check', formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'accept': 'application/json'
      }
    });

    return response.data;
  }
}; 